let loading;
export function loadEphemonCore() {
    if (loading === undefined) {
        loading = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = `${process.env.EPHEMON_CLIENT_URL}/core.min.js?_=${process.env.EPHEMON_BUILD_TIMESTAMP}`;
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => {
                loading = undefined;
                script.remove();
                reject(new Error('Unable to load core.min.js.'));
            };
            document.head.appendChild(script);
        });
    }
    return loading;
}
